import {
  LANG_LIST,
  LOCALE_MAP_TO_WEGLOT,
  DEFAULT_LOCALE,
} from "constants/lang";
import { getCookieValue } from "utility";

import type { LanguageType, WeglotKey } from "constants/lang";

declare global {
  // グローバルな型の拡張（declaration merging）にはinterfaceが必要なので以下を無視する
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    Weglot?: unknown;
  }
}

export const TRANSLATE_THIS_BLOCK_BY_WEGLOT = "translate-this-block";

export type WeglotType = {
  initialize: ({
    api_key,
    hide_switcher,
    excluded_blocks,
  }: {
    api_key: string;
    hide_switcher: boolean;
    excluded_blocks?: Array<{ value: string }>;
    whitelist?: Array<{ value: string }>;
  }) => void;
  switchTo: (lang: WeglotKey) => void;
  getBestAvailableLanguage: () => LanguageType["value"];
  on: (event: string, callback: () => void) => void;
};

const isWeglotType = (obj: unknown): obj is WeglotType => {
  return (
    !!obj &&
    typeof obj === "object" &&
    "switchTo" in obj &&
    typeof obj.switchTo === "function" &&
    "getBestAvailableLanguage" in obj &&
    typeof obj.getBestAvailableLanguage === "function" &&
    "initialize" in obj &&
    typeof obj.initialize === "function" &&
    "on" in obj &&
    typeof obj.on === "function"
  );
};

export const initializeCallback = (weglot: WeglotType) => {
  const { value: languageValue } = getLanguageType();
  weglot.switchTo(LOCALE_MAP_TO_WEGLOT[languageValue]);
};

const initializeWeglot = (weglot: WeglotType): void => {
  weglot.on("initialized", () => {
    initializeCallback(weglot);
  });

  weglot.initialize({
    api_key: "wg_0d7e91dc096443229c0155974a1bd34e6",
    hide_switcher: true,
    whitelist: [
      {
        value: `.${TRANSLATE_THIS_BLOCK_BY_WEGLOT}`, // All elements with this class will be translated
      },
    ],
  });
};

const getWeglot = (): WeglotType | undefined => {
  if (typeof window === "undefined") return undefined;
  const weglot = window.Weglot;

  if (isWeglotType(weglot)) {
    return weglot;
  }
  return undefined;
};

/**
 * cookieから言語を取得する.
 * cookieがない場合、Weglot有効時はブラウザの言語設定を使用し、無効時はデフォルトで"ja"を使用する.
 */
export const getLanguageType = (): LanguageType => {
  try {
    const cookieLang = getCookieValue("lang");
    if (cookieLang) {
      const found = LANG_LIST.find((lang) => lang.value === cookieLang);
      if (found) {
        return found;
      }
    }

    // TODO: cookieがない場合、ブラウザの言語設定を使用するようにする

    return DEFAULT_LOCALE;
  } catch (e) {
    console.error(e);
    return DEFAULT_LOCALE;
  }
};

export const setInitialLanguageToWeglot = () => {
  const weglot = getWeglot();
  if (weglot) {
    initializeWeglot(weglot);
  }
};
